// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"292e4156","239":"c3289c7d","453":"0568352b","667":"5f108e32"}[chunkId] + ".chunk.js";
};